module.exports = __webpack_public_path__ + "img/slider_contact.1a2e0829.jpg";